import { ReviewCardProps } from "@made-people/blueprint-review-card";
import { TrustpilotLogo } from "../../../assets/icons/TrustpilotLogo";
import { MissMaryLogo } from "../../../assets/icons/MissMaryLogo";

export const ReviewCard = {
  collectedByOptions: [
    {
      logo: <TrustpilotLogo className="w-12 h-fit" />,
      id: "trustpilot",
    },
    {
      logo: <MissMaryLogo className="w-10 h-fit" />,
      id: "miss-mary",
    },
    {
      logo: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-4 h-fit"
        >
          <path d="M15.2 14.3c-1.1 1.7-2.6 3.1-4.7 3.1-2.2 0-3.4-1.3-3.4-3.5 0-3.6 2.6-7 6.3-7 1.2 0 3 .4 3 2 0 2.6-4.3 3.5-6.4 4l-.1 1.4c0 1 .5 1.8 1.5 1.8 1.3 0 2.4-1.3 3.2-2.2zM14 8.5c0-.5-.3-1-.8-1-1.8 0-2.7 3.4-3 4.7 1.6-.5 3.8-1.8 3.8-3.7zM12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm-.1 19.5a7.6 7.6 0 1 1 7.6-7.5 7.6 7.6 0 0 1-7.6 7.5Z" />
        </svg>
      ),
      id: "trusted-shops",
    },
  ],
} satisfies ReviewCardProps;
